export let PremiumSharedResource = /*#__PURE__*/function (PremiumSharedResource) {
  PremiumSharedResource["ApisClientContext"] = "ApisClientContext";
  PremiumSharedResource["QueryClientInstance"] = "QueryClientInstance";
  PremiumSharedResource["EssentialsContext"] = "EssentialsContext";
  PremiumSharedResource["EssentialsInstancesRef"] = "EssentialsInstancesRef";
  PremiumSharedResource["ModulesContexts"] = "ModulesContexts";
  PremiumSharedResource["ModulesStores"] = "ModulesStores";
  PremiumSharedResource["TestingUtils"] = "TestingUtils";
  return PremiumSharedResource;
}({});
//# sourceMappingURL=types.js.map